// extracted by mini-css-extract-plugin
export default {"container":"About_container__pxvGf","background":"About_background__5Kc9h","header-image":"About_header-image__Mwdg5","body":"About_body__yUQ1q"};